import {
  StakeFiatCurrency,
  StakeOptionList,
  TournamentsStakeOptionsClient,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const tournamentsDefaultClient = new TournamentsStakeOptionsClient(
  apiConfig,
  undefined,
  axiosInstance
);

export const handleGetStakeOptions = async (
  currency?: StakeFiatCurrency
): Promise<StakeOptionList | undefined> => {
  return (await tournamentsDefaultClient.getStakeOptions(currency)).data;
};
